let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3GtAT")).then(() => parcelRequire('d0bjG'));